export const SPINNER_LIGHT_GREEN = '#36d7b7';
export const GOLDEN_HEALTH_ORANGE = '#f7931d';
export const WHITE = '#ffffff';
export const BLACK = '#000000';
